<template>
  <v-container class="profile-page" style="min-height: 100vh">
    <v-row class="my-1">
      <v-col cols="12" md="10" sm="9">
        <h2>
          <span class="grey--text"
            >{{ $t("employees.title") }} ({{
              employees ? employees.length : 0
            }})</span
          >
        </h2>
      </v-col>
      <v-col cols="12" class="text-left" md="2" sm="3">
        <v-btn
          :disabled="!permission.employees"
          block
          color="success"
          to="/app/employees/new"
          >{{ $t("employees.createBtn")
          }}<v-icon class="ml-2">mdi-account</v-icon></v-btn
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="employees"
        ><TableEmployees :data="employees" />
      </v-col>
      <v-col cols="12" v-else>
        <v-card class="text-center py-16" elevation="0">
          <h3 class="gray-text ma-3">{{ $t("employees.empty") }}</h3>
          <P class="gray-text">{{ $t("employees.lable") }}.</P>
          <v-chip
            close-icon="mdi-delete"
            color="primary"
            to="/app/employees/new"
            label
            outlined
            :disabled="!permission.employees"
            >{{ $t("employees.createBtn") }}
          </v-chip>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import TableEmployees from "./TableEmployees.vue";
export default {
  name: "employee-page",
  components: { TableEmployees },
  data() {
    return {
      clicked: false,
      param: null,
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 6 || "Min 6 characters",
      },
    };
  },
  computed: {
    ...mapState("users", ["permission"]),
    ...mapGetters("employees", ["employees"]),
  },
  methods: { ...mapActions("employees", ["list"]) },
  // created() {
  //   this.param = this.$router.history.current.params;
  // },
  mounted() {
    this.list();
  },
};
</script>
